// ProstateCard.jsx

import React from "react";
import BasePackageCard from "./BasePackageCard";
import { PROSTATE } from "../../../../constants";
import { useTranslation } from "../../../../language";

export default function ProstateCard() {
  const { t } = useTranslation();

  const panel = {
    id: "prostate",
    title: t("card_prostate_title"),
    subtitle: t("card_prostate_desc"),
    biomarkers: t("card_prostate_markers"),
    price: "€ 19",
    image: PROSTATE,
  };

  return <BasePackageCard panel={panel} />;
}